import { cx } from 'cvb';
import PropTypes from 'prop-types';
import ComboItemsDesktop from '../../../components/ComboSection/ComboItemsDesktop';
import MordenImageGallery from '../../../components/ImageGallery/MordenImageGallery';
import ProductOutOfStock from '../../../components/ProductOutOfStock/ProductOutOfStock';
import ProductSpecificationConnect from '../../../components/ProductSpecificationConnect/v2';
import SellerRatings from '../../../components/SellerRatings/SellerRatings';
import Breadcrumbs from '../../../components/ui/Breadcrumbs';
import ProductSpecificationsAccordion from '../../../components/ui/ProductSpecificationsAccordion/ProductSpecificationsAccordion';
import constants from '../../../config/constants';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { withLabels } from '../../../utils/LabelsContext';
import _ from '../../../utils/LodashImports';
import * as productUtils from '../../../utils/product/productUtils';
import { withProduct } from '../../../utils/ProductContext';
import { withUser } from '../../../utils/UserContext';
import { getVariant } from '../../../utils/variant';
import ConnectTab from '../../HardLineProductContainer/ConnectTab/v2';
import ProductSpecifications from '../../ProdctSpecifications/ProductSpecifications';
import PDPBasicInfoDesktop from './containers/PDPBasicInfoDesktop';
import ModernLineDesktopStyles from './style';

const PDPDesktop = ({ product, labels, isVendorLogin, appCtx }) => {
  const { isOutOfStock, breadCrumb, variants, currentVariant } = product;
  const variant = getVariant(variants, currentVariant);
  const comboData = _.get(variant, 'comboData', null);
  const productSpecification = <ProductSpecifications layoutType={constants.PRODUCT_CONSTANTS.SOFTLINE} />;
  const isConnectProduct = productUtils.isConnectProduct(product);
  const isSellerRatingsEnabled = _.get(appCtx, 'siteConfig.toggles.isSellerRatingsEnabled', true);

  const productSpecificationView = () => {
    const connectProductTabData = [
      {
        title: () => labels.TEAM?.toLowerCase(),
        content: () => productSpecification,
      },
      {
        title: () => labels.PLANES?.toLowerCase(),
        content: () => <ProductSpecificationConnect />,
      },
    ];

    if (isConnectProduct) return <ConnectTab tabData={connectProductTabData} />;
    if (!isVendorLogin) return productSpecification;

    const tabData = [
      {
        title: (flag) => (
          <div className="modern-pdp__tab">
            <span
              className={cx('modern-pdp__tab-icon', 'modern-pdp__tab-icon--internet', {
                'modern-pdp__tab-icon--active': !flag,
                'modern-pdp__tab-icon--disabled': flag,
              })}
            />
            <span className="modern-pdp__tab-label">INTERNET</span>
            <style jsx>{ModernLineDesktopStyles}</style>
          </div>
        ),
        content: () => productSpecification,
      },
      {
        title: (flag) => (
          <div className="modern-pdp__tab">
            <span
              className={cx('modern-pdp__tab-icon', 'modern-pdp__tab-icon--tienda', {
                'modern-pdp__tab-icon--active': !flag,
                'modern-pdp__tab-icon--disabled': flag,
              })}
            />
            <span className="modern-pdp__tab-label">TIENDA</span>
            <style jsx>{ModernLineDesktopStyles}</style>
          </div>
        ),
        content: () => <ProductSpecifications layoutType={constants.PRODUCT_CONSTANTS.SOFTLINE} currentTab="Tienda" />,
      },
    ];

    return <ConnectTab tabData={tabData} />;
  };

  const isSoftlineProduct = product.layoutType === constants.PRODUCT_CONSTANTS.SOFTLINE;

  return (
    <>
      <div className="modern-pdp">
        <div className="modern-pdp__container">
          <div className="modern-pdp__breadcrumbs">
            <Breadcrumbs items={breadCrumb} appCtx={appCtx} isPdpPage />
          </div>
          <div className="modern-pdp__content">
            <section
              className={cx('modern-pdp__image-section', {
                'modern-pdp__image-section--hardline': !isSoftlineProduct,
              })}
            >
              <div className="modern-pdp__gallery">
                <MordenImageGallery />
              </div>
              <div className="modern-pdp__accordion">
                <ProductSpecificationsAccordion product={product} labels={labels} appCtx={appCtx} />
              </div>
              {comboData && (
                <div className="modern-pdp__combo">
                  <ComboItemsDesktop comboData={comboData} />
                </div>
              )}
            </section>
            <section
              className={cx('modern-pdp__details-section', {
                'modern-pdp__details-section--hardline': !isSoftlineProduct,
              })}
            >
              <header className="modern-pdp__details-header">
                <PDPBasicInfoDesktop product={product} labels={labels} appCtx={appCtx} />
              </header>
              <div className="modern-pdp__details-body">
                <div className="modern-pdp__specifications">
                  {isOutOfStock ? <ProductOutOfStock /> : productSpecificationView()}
                </div>
                {isSellerRatingsEnabled && product.sellerInfo?.rating && (
                  <div className="modern-pdp__seller-ratings">
                    <SellerRatings sellerInfo={product.sellerInfo} />
                  </div>
                )}
              </div>
            </section>
          </div>
        </div>
      </div>
      <section className="pdp-detail-section" />
      <style jsx>{ModernLineDesktopStyles}</style>
    </>
  );
};

PDPDesktop.propTypes = {
  product: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  isVendorLogin: PropTypes.bool.isRequired,
  appCtx: PropTypes.object.isRequired,
};

export { PDPDesktop };
export default withUser(withProduct(withLabels(withApplicationContext(PDPDesktop))));
